import React, { ReactNode } from 'react';
import * as S from './Button.style';

export enum ButtonVariant {
  ADD = 'ADD',
  INFO = 'INFO',
  SUBMIT = 'SUBMIT',
  SCORE = 'SCORE',
  DELETE = 'DELETE',
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  onClick?: () => void;
  children?: ReactNode;
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  type = 'button',
  variant,
  onClick,
  children,
  disabled,
  ...props
}) => {
  const getButtonComponent = () => {
    switch (variant) {
      case ButtonVariant.ADD:
        return S.AddButton;
      case ButtonVariant.INFO:
        return S.InfoButton;
      case ButtonVariant.SUBMIT:
        return S.SubmitButton;
      case ButtonVariant.SCORE:
        return S.ScoreButton;
      case ButtonVariant.DELETE:
        return S.DeleteButton;
      default:
        return S.Button;
    }
  };

  const StyledButton = getButtonComponent();

  return (
    <StyledButton type={type} onClick={onClick} disabled={disabled} {...props}>
      {children}
    </StyledButton>
  );
};
